import { Candidate, CandidateStage } from '../types';

export const generateMockCandidates = (): Candidate[] => [
  {
    id: '1',
    name: 'Amina Hassan Al-Zahra',
    email: 'amina.hassan@email.com',
    phone: '+965-9876-5432',
    passportNumber: 'A1234567',
    jobTitle: 'Senior Housemaid',
    company: 'Al-Sabah Family',
    salary: 350,
    countryApplyingTo: 'Kuwait',
    stage: 'Hired' as CandidateStage,
    lastContacted: '2024-01-15',
    cvFileName: 'amina_hassan_cv.pdf',
    notes: 'Excellent references from previous employer. Speaks Arabic and English fluently.',
    avatarUrl: undefined
  },
  {
    id: '2',
    name: 'Fatima Al-Mahmoud',
    email: 'fatima.mahmoud@email.com',
    phone: '+965-8765-4321',
    passportNumber: 'B2345678',
    jobTitle: 'Barista',
    company: 'Coffee Corner Kuwait',
    salary: 280,
    countryApplyingTo: 'Kuwait',
    stage: 'Offer' as CandidateStage,
    lastContacted: '2024-01-18',
    cvFileName: 'fatima_mahmoud_cv.pdf',
    notes: 'Great coffee skills, 3 years experience in specialty coffee.',
    avatarUrl: undefined
  },
  {
    id: '3',
    name: 'Mohammed Al-Rashid',
    email: 'mohammed.rashid@email.com',
    phone: '+965-7654-3210',
    passportNumber: 'C3456789',
    jobTitle: 'Heavy Truck Driver',
    company: 'Kuwait Transport Co.',
    salary: 450,
    countryApplyingTo: 'Kuwait',
    stage: 'Interviewing' as CandidateStage,
    lastContacted: '2024-01-19',
    cvFileName: 'mohammed_rashid_cv.pdf',
    notes: 'Valid heavy vehicle license. 8 years driving experience. Clean driving record.',
    avatarUrl: undefined
  },
  {
    id: '4',
    name: 'Aisha Abdullah',
    email: 'aisha.abdullah@email.com',
    phone: '+965-6543-2109',
    passportNumber: 'D4567890',
    jobTitle: 'Construction Worker',
    company: 'Gulf Construction Ltd.',
    salary: 320,
    countryApplyingTo: 'Kuwait',
    stage: 'Onboarding' as CandidateStage,
    lastContacted: '2024-01-20',
    cvFileName: 'aisha_abdullah_cv.pdf',
    notes: 'Strong physical condition. Experience in residential construction.',
    avatarUrl: undefined
  },
  {
    id: '5',
    name: 'Salem Al-Mutairi',
    email: 'salem.mutairi@email.com',
    phone: '+965-5432-1098',
    passportNumber: 'E5678901',
    jobTitle: 'Security Guard',
    company: 'SecureKuwait Services',
    salary: 300,
    countryApplyingTo: 'Kuwait',
    stage: 'Rejected' as CandidateStage,
    lastContacted: '2024-01-12',
    cvFileName: 'salem_mutairi_cv.pdf',
    notes: 'Failed background check - previous employment issues.',
    avatarUrl: undefined
  },
  {
    id: '6',
    name: 'Layla Al-Habib',
    email: 'layla.habib@email.com',
    phone: '+965-4321-0987',
    passportNumber: 'F6789012',
    jobTitle: 'Waitress',
    company: 'Marina Bay Restaurant',
    salary: 250,
    countryApplyingTo: 'Kuwait',
    stage: 'Interviewing' as CandidateStage,
    lastContacted: '2024-01-17',
    cvFileName: 'layla_habib_cv.pdf',
    notes: 'Excellent customer service skills. Multilingual - Arabic, English, French.',
    avatarUrl: undefined
  },
  {
    id: '7',
    name: 'Omar Al-Salim',
    email: 'omar.salim@email.com',
    phone: '+965-3210-9876',
    passportNumber: 'G7890123',
    jobTitle: 'Cleaner',
    company: 'CleanPro Kuwait',
    salary: 200,
    countryApplyingTo: 'Kuwait',
    stage: 'Onboarding' as CandidateStage,
    lastContacted: '2024-01-21',
    cvFileName: 'omar_salim_cv.pdf',
    notes: 'Reliable and punctual. Experience in commercial cleaning.',
    avatarUrl: undefined
  },
  {
    id: '8',
    name: 'Mariam Al-Fahad',
    email: 'mariam.fahad@email.com',
    phone: '+965-2109-8765',
    passportNumber: 'H8901234',
    jobTitle: 'Registered Nurse',
    company: 'Kuwait Medical Center',
    salary: 600,
    countryApplyingTo: 'Kuwait',
    stage: 'Offer' as CandidateStage,
    lastContacted: '2024-01-16',
    cvFileName: 'mariam_fahad_cv.pdf',
    notes: 'RN license valid. 5 years ICU experience. Excellent patient care record.',
    avatarUrl: undefined
  },
  {
    id: '9',
    name: 'Khalid Al-Mansouri',
    email: 'khalid.mansouri@email.com',
    phone: '+965-1098-7654',
    passportNumber: 'I9012345',
    jobTitle: 'English Teacher',
    company: 'International School Kuwait',
    salary: 800,
    countryApplyingTo: 'Kuwait',
    stage: 'Interviewing' as CandidateStage,
    lastContacted: '2024-01-14',
    cvFileName: 'khalid_mansouri_cv.pdf',
    notes: 'TESOL certified. Masters in Education. 10 years teaching experience.',
    avatarUrl: undefined
  },
  {
    id: '10',
    name: 'Nora Al-Ahmad',
    email: 'nora.ahmad@email.com',
    phone: '+965-0987-6543',
    passportNumber: 'J0123456',
    jobTitle: 'Personal Driver',
    company: 'Elite Chauffeur Services',
    salary: 380,
    countryApplyingTo: 'Kuwait',
    stage: 'Hired' as CandidateStage,
    lastContacted: '2024-01-13',
    cvFileName: 'nora_ahmad_cv.pdf',
    notes: 'Professional driving certificate. VIP client experience. Female driver preferred.',
    avatarUrl: undefined
  },
  {
    id: '11',
    name: 'Hassan Al-Qadri',
    email: 'hassan.qadri@email.com',
    phone: '+965-9876-0123',
    passportNumber: 'K1234560',
    jobTitle: 'Chef Assistant',
    company: 'Royal Kuwait Hotel',
    salary: 350,
    countryApplyingTo: 'Kuwait',
    stage: 'Onboarding' as CandidateStage,
    lastContacted: '2024-01-22',
    cvFileName: 'hassan_qadri_cv.pdf',
    notes: 'Culinary school graduate. Specializes in Middle Eastern cuisine.',
    avatarUrl: undefined
  },
  {
    id: '12',
    name: 'Zahra Al-Kindi',
    email: 'zahra.kindi@email.com',
    phone: '+965-8765-0123',
    passportNumber: 'L2345601',
    jobTitle: 'Office Cleaner',
    company: 'Corporate Clean Kuwait',
    salary: 220,
    countryApplyingTo: 'Kuwait',
    stage: 'Rejected' as CandidateStage,
    lastContacted: '2024-01-10',
    cvFileName: 'zahra_kindi_cv.pdf',
    notes: 'Did not meet physical requirements. Health clearance issues.',
    avatarUrl: undefined
  }
];

export const CANDIDATE_STAGE_COLORS: Record<CandidateStage, { bg: string; text: string; border: string }> = {
  'Onboarding': {
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    border: 'border-blue-200'
  },
  'Interviewing': {
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    border: 'border-yellow-200'
  },
  'Offer': {
    bg: 'bg-purple-100',
    text: 'text-purple-800',
    border: 'border-purple-200'
  },
  'Hired': {
    bg: 'bg-green-100',
    text: 'text-green-800',
    border: 'border-green-200'
  },
  'Rejected': {
    bg: 'bg-red-100',
    text: 'text-red-800',
    border: 'border-red-200'
  }
};

export const CANDIDATE_STAGES: CandidateStage[] = ['Onboarding', 'Interviewing', 'Offer', 'Hired', 'Rejected'];